export default commomImport => [{
  path: `finance-manager`,
  name: 'FinanceManager',
  meta: {
    title: 'store.financeManager'
  },
  //  全部订单
  component: commomImport('store-manager/finance-manager')
}];
